<template>
  <div class="container">
    <div class="header">
      <!-- 图片 -->
      <div class="banner">
        <img :src="bannerFile" alt="" />
      </div>
      <!-- 喇叭 -->
      <div class="notice">
        <i class="iconfont icon-horn">预约报名</i>
        | 截止到目前已经有{{ persons }}人预约了
      </div>
    </div>
    <!-- 按钮 -->
    <div class="imgs">
      <div class="left" style="margin-right: 20px" @click="_showD">
        预约检测
      </div>
      <div class="right" @click="_toquestionPage">问卷调查</div>
    </div>
    <!-- 预约信息 -->
    <div class="userInfo" id="userInfoBox">
      <div class="tips" v-for="(item, index) in userList" :key="index">
        {{ item.o_name }} {{ item.o_phone }} 预约成功
      </div>
    </div>
    <!-- 信息公示 -->
    <div class="news">
      <div class="nationNews sameNews" @click="_toListPage(1)">
        <div class="top">
          <div class="topLeft">
            国家艾滋病治疗最新消息
            <span>查看更多<i class="iconfont icon-youjiantou"></i></span>
          </div>
          <div class="topRight"></div>
        </div>
        <div class="bottom">
          <div class="texts" v-for="(item, index) in nationNews" :key="index">
            <div class="circle"></div>
            <div class="text-content">{{ item.a_title }}</div>
            <div class="a_release_time">{{ item.a_release_time }}</div>
          </div>
        </div>
      </div>
      <div
        class="localNews sameNews"
        @click="_toListPage(2)"
        style="margin: 15px 0"
      >
        <div class="top">
          <div class="topLeft">
            当地宣传活动公告
            <span>查看更多<i class="iconfont icon-youjiantou"></i></span>
          </div>
          <div class="topRight"></div>
        </div>
        <div class="bottom">
          <div class="texts" v-for="(item, index) in localNews" :key="index">
            <div class="circle"></div>
            <div class="text-content">{{ item.a_title }}</div>
            <div class="a_release_time">{{ item.a_release_time }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog
      v-model="dialogFormVisible"
      style="margin-top: 30vh; border-radius: 10px"
      title="预约检测"
      width="350"
      @close="_closeDialog"
    >
      <el-form :model="form">
        <el-form-item>
          <el-radio-group v-model="radio">
            <el-radio
              :value="0"
              size="large"
              fill="#1242fc"
              text-color="#1242fc"
              >在线预约</el-radio
            >
            <el-radio :value="1" size="large">邮寄检测</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <div class="dis-row-d">
            <el-input
              v-model="form.o_name"
              autocomplete="off"
              :disabled="nameDisabled"
            />
            <span style="margin-left: 10px; min-width: 40px">匿名</span>
            <el-switch
              v-model="isNiming"
              inline-prompt
              active-text="是"
              inactive-text="否"
              @change="_changeNiming"
            />
          </div>
        </el-form-item>

        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.o_phone" autocomplete="off" />
        </el-form-item>
        <el-form-item label="检查项目" :label-width="formLabelWidth">
          <el-select v-model="form.O_CAUSE" placeholder="请选择项目">
            <el-option
              v-for="item in causeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约时间" :label-width="formLabelWidth">
          <el-date-picker
            ref="oTimePicker"
            v-model="form.O_TIME"
            type="datetime"
            placeholder="请选择时间"
            :disabled-date="disabledDate"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer" style="text-align: center">
          <el-button
            color="#1242fc"
            style="width: 230px; justify-content: center"
            @click="_submitInfo"
          >
            提交
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import http from '@/util/http'
import { timestampToDate } from '@/util/timeToTranser'
import { ElMessage } from 'element-plus'
import Cookies from 'js-cookie'
export default {
  name: 'homeView',
  data() {
    return {
      isNiming: false,
      nameDisabled: false,
      name: '',
      oldName: '',
      radio: '',
      dialogFormVisible: false,
      bannerFile: require('@/assets/images/banner.png'),
      bgi: require('@/assets/images/button.jpg'),
      persons: '200',
      formLabelWidth: '70px',
      form: {
        o_category: '',
        o_name: '',
        o_phone: '',
        O_CAUSE: [],
        O_TIME: null,
        nowDate: null // 存储当前时间戳转换的日期
      },
      userList: [],
      nationNews: [],
      localNews: [],
      causeOptions: [
        // 下拉选项列表
        { value: 'option1', label: '丙肝' },
        { value: 'option2', label: '梅毒' },
        { value: 'option3', label: 'HIV' },
        { value: 'option4', label: '三联' }
      ]
    }
  },

  async created() {
    try {
      const response = await http.get('/timestamp')
      const timestampStr = response.data.now // 假设返回的JSON格式为 { now: '1688950800000' }
      const timestamp = Number(timestampStr)
      this.nowDate = new Date(timestamp * 1000)
    } catch (error) {
      console.error('Error fetching timestamp:', error)
    }
  },

  computed: {},

  mounted() {
    this._getPerson()
    this._getUserInfo()
    this._getNationNewsList()
    this._getLocalNewsList()
    this._getTimestamp()
  },
  unmounted() {
    this.intervalId && clearInterval(this.intervalId)
  },
  methods: {
    _showD() {
      this.dialogFormVisible = true
      this.oldName = undefined
    },
    _changeNiming(e) {
      this.nameDisabled = e
      if (e) {
        this.oldName = this.form.o_name
        this.form.o_name = '匿名'
      } else {
        this.form.o_name = this.oldName
      }
    },
    _getTimestamp() {
      http.get('timestamp/').then(res => {
        if (res.code === 200) {
          Cookies.set('startTime', timestampToDate(res.data.firstDay, 1))
          Cookies.set('nowTime', timestampToDate(res.data.now, 1))
        }
      })
    },
    disabledDate(date) {
      const endTime = Cookies.get('nowTime')
      // 确保 endTime 存在并转换为 Date 对象
      if (!endTime) {
        console.warn('endTime 未设置，无法进行日期禁用判断')
        return false // 或者根据实际情况决定是否禁用所有日期
      }
      const endDate = new Date(endTime)

      // 获取当前日期是周几，0 代表周日，6 代表周六
      const dayOfWeek = date.getDay()

      // 如果日期在 endTime 之前，直接禁用
      if (date < endDate) {
        return true
      }

      // 对于 endTime 之后的日期，只允许选择周六和周日
      return dayOfWeek !== 0 && dayOfWeek !== 6
    },

    _toquestionPage() {
      this.$router.push('/questions')
      clearInterval(this.intervalId)
    },
    _toListPage(id) {
      this.$router.push({
        path: '/list',
        query: {
          id: id
        }
      })
      clearInterval(this.intervalId)
    },
    _getPerson() {
      http.get('/order').then(res => {
        console.log(res)
        if (res.code == 200) {
          this.persons = res.data
          console.log(this.persons)
        }
      })
    },

    _submitInfo() {
      // 假设 this.form.o_time 是一个标准的日期时间字符串，如 "2023-04-01 12:00:00"
      if (this.form.O_TIME) {
        // 创建一个Date对象
        const date = new Date(this.form.O_TIME)
        // 将Date对象转换为毫秒级时间戳
        const timestamp = date.getTime()
        // 更新表单数据中的时间字段为13位时间戳
        this.form.O_TIME = timestamp
      }
      this.form.o_category = this.radio
      this.form.O_CAUSE = JSON.stringify([this.form.O_CAUSE])
      http.post('/order', this.form).then(res => {
        if (res.code === 200) {
          ElMessage.success('提交成功')
          this.dialogFormVisible = false
          this.form = {
            o_category: '',
            o_name: '',
            o_phone: '',
            O_CAUSE: undefined,
            O_TIME: null,
            nowDate: null // 存储当前时间戳转换的日期
          }
        } else {
          this.$message('请输入正确信息')
        }
      })
    },

    _closeDialog() {
      ;(this.isNiming = false),
        (this.radio = ''),
        (this.nameDisabled = false),
        (this.form = {
          o_category: undefined,
          o_name: undefined,
          o_phone: undefined,
          O_CAUSE: undefined,
          O_TIME: null,
          nowDate: null // 存储当前时间戳转换的日期
        })
    },

    _getUserInfo() {
      http
        .get('/orderWeb/info', {
          pageSize: 40
        })
        .then(res => {
          if (res.code == 200) {
            this.userList = res.data.list
            if (this.userList.length > 0) {
              this._autoScroll()
            }
          }
        })
    },
    _getNationNewsList() {
      http.get('article/type_01?o_type').then(res => {
        if (res.code == 200) {
          for (const i in res.data.list) {
            if (i >= 4) {
              break
            }
            this.nationNews.push(res.data.list[i])
          }
        }
      })
    },
    _getLocalNewsList() {
      http.get('article/type_02?o_type').then(res => {
        if (res.code == 200) {
          for (const i in res.data.list) {
            if (i >= 4) {
              break
            }
            this.localNews.push(res.data.list[i])
          }
        }
      })
    },
    _autoScroll() {
      let scrollTopPx = 0
      this.intervalId = setInterval(() => {
        const scrollBox = document.getElementById('userInfoBox')
        if (!scrollBox) {
          return
        }
        scrollTopPx += 3
        const isAtBottom =
          scrollBox.scrollTop >=
          scrollBox.scrollHeight - scrollBox.clientHeight - 2
        if (isAtBottom) {
          scrollTopPx = 0
        }
        this.$nextTick(() => {
          scrollBox.scrollTop = scrollTopPx
        })
      }, 300)
    }
  },

  beforeDestroy() {
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f1eff0;
  overflow-y: scroll;
}

.header {
  position: relative;
  width: 100%;
}

.banner {
  border-bottom-left-radius: 20%;
  border-bottom-right-radius: 20%;
  overflow: hidden;
}

.banner img {
  width: 100%;
}

.notice {
  width: 90%;
  height: 40px;
  font-size: 14px;
  border-radius: 20px;
  /* border: 1px solid #f57a7f; */
  box-shadow: 0px 6px 2px #cbcbcb;
  background-color: #fff;
  text-align: center;
  line-height: 40px;
  position: absolute;
  left: 20px;
  bottom: -20px;
}

.notice i {
  color: #1242fc;
  font-size: 14px;
  margin-right: 5px;
}

.imgs {
  width: 90%;
  margin-top: 35px;
  /* background-color: #f00; */
  display: flex;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}

.imgs div {
  width: 50%;
  height: 66px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.imgs .left {
  background: url('@/assets/images/button.jpg');
  background-size: cover;
}

.imgs .right {
  background: url('@/assets/images/button.jpg');
  background-size: cover;
}

.news {
  width: 90%;
  display: flex;
  flex-direction: column;
  height: 600px;
  margin-top: 15px;
  color: #fff;
  font-size: 16px;
}

.news .top {
  height: 21px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.news .topLeft {
  height: 100%;
  font-size: 16px;
  padding: 5px 15px;
  background: url('@/assets/images/left.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.news .topLeft span {
  margin-left: 5px;
}

.news .topRight {
  /* flex: 1; */
  max-width: 120px;
  min-width: 60px;
  padding: 5px 0;
  height: 100%;
  background: url('@/assets/images/right.svg');
  background-repeat: no-repeat;
  background-size: cover;
}

.news .sameNews {
  width: 100%;
  max-height: calc(50% - 10px);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.news .bottom {
  margin-top: 10px;
}

.texts {
  width: calc(100% - 26px);
  max-width: calc(100% - 26px);
  line-height: 34px;
  background-color: #fff;
  padding: 0 13px;
  color: #000;
  font-size: 14px;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.news span {
  font-size: 10px;
}

.news i {
  font-size: 10px;
}

.el-radio {
  border-radius: 15px;
}

.el-radio-group {
  display: flex;
  justify-content: center;
}

.el-form-item__content {
  justify-content: center;
}

form {
  display: flex;
  flex-direction: column;
}

.el-form-item {
  width: 280px;
  align-items: center;
  justify-content: center;
}

.userInfo {
  width: 90%;
  height: 45px;
  max-height: 45px;
  min-height: 45px;
  border-radius: 5px;
  background-color: #fff;
  margin-top: 15px;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  display: none;
}

.userInfo .tips {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: pink; */
}

.tips {
  width: calc(50% - 12px);
  height: calc(50% - 4px);
  box-sizing: border-box;
  margin: 1px 5px;
  font-size: 10px;
  line-height: 20px;
}

.el-radio {
}

:deep() .el-radio__input.is-checked .el-radio__inner {
  background-color: #1242fc !important;
  border-color: #1242fc !important;
}

:deep() .el-radio__input.is-checked + .el-radio__label {
  color: #1242fc !important;
}

.dis-row-d {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.circle {
  width: 8px;
  height: 6px;
  border-radius: 50%;
  background-color: #1242fc;
}

.text-content {
  width: calc(100% - 8px - 80px); /* 限定宽度 */
  overflow: hidden; /* 隐藏超出部分 */
  white-space: nowrap; /* 文本不换行 */
  text-overflow: ellipsis; /* 超出部分显示为省略号 */
  display: block;
  margin-left: 10px;
}

.a_release_time {
  width: 80px; /* 限定宽度 */
  overflow: hidden; /* 隐藏超出部分 */
  white-space: nowrap; /* 文本不换行 */
  overflow: hidden;
  display: block;
  color: #999;
  margin-left: 20px;
  min-width: 80px;
  max-width: 80px;
}
</style>
